{********************************************************************}
{                                                                    }
{ written by TMS Software                                            }
{            Copyright (c) 2018 - 2025                               }
{            Email : info@tmssoftware.com                            }
{            Web : http://www.tmssoftware.com                        }
{                                                                    }
{ The source code is given as is. The author is not responsible      }
{ for any possible damage done due to the use of this code.          }
{ The complete source code remains property of the author and may    }
{ not be distributed, published, given or sold in any form as such.  }
{ No parts of the source code can be included in any other component }
{ or application without written authorization of the author.        }
{********************************************************************}

unit WEBLib.Toast;

{$DEFINE NOPP}

interface

// https://getbootstrap.com/docs/4.3/components/toasts/
// https://www.tutorialrepublic.com/twitter-bootstrap-tutorial/bootstrap-toasts.php
// https://www.w3schools.com/howto/howto_js_add_class.asp
// event for click

uses
  Web, Classes, SysUtils, WEBLib.Controls, WEBLib.ExtCtrls;


type
  TToast = class;

  TToastPosition = (tpTopLeft,tpTopRight, tpBottomLeft, tpBottomRight, tpAbsolute, tpContainer);

  TToastTime = (ttNone, ttShow, ttDeltaShow);

  TToastItem = class(TCollectionItem)
  private
    FBody: string;
    FHeader: string;
    FCloseButton: boolean;
    FElementHandle: TJSHTMLElement;
    FElementTime: TJSHTMLElement;
    FAutoHide: boolean;
    FTime: TToastTime;
    FDispTime: TDateTime;
    FVisible: boolean;
    FID: integer;
    FTag: integer;
    procedure SetVisible(const Value: boolean);
  protected
    function ToastID: string;
    procedure UpdateToast(el: TJSHTMLElement);
  public
    constructor Create(ACollection: TCollection); override;
    destructor Destroy; override;
    procedure Assign(Source: TPersistent); override;
    procedure Show;
    procedure Hide;
    function CreateToast: TJSHTMLElement;
    procedure Update;
    function Toast: TToast; virtual;
    property Visible: boolean read FVisible write SetVisible;
  published
    property AutoHide: boolean read FAutoHide write FAutoHide default false;
    property Body: string read FBody write FBody;
    property CloseButton: boolean read FCloseButton write FCloseButton default true;
    property Tag: integer read FTag write FTag default 0;
    property Time: TToastTime read FTime write FTime;
    property Header: string read FHeader write FHeader;
  end;

  TToastCollection = class(TOwnedCollection)
  private
    FUniqueID: integer;
    function GetItem(AIndex: integer): TToastItem; reintroduce;
    procedure SetItem(AIndex: integer; const Value: TToastItem);
  protected
    property UniqueID: integer read FUniqueID write FUniqueID;

  public
    constructor Create(AOwner: TComponent); reintroduce;
    function Add(AHeader,ABody: string): TToastItem; overload; reintroduce;
    function Add: TToastItem; overload; reintroduce;
    function Insert(Index: integer): TToastItem; reintroduce;
    property Items[AIndex: integer]: TToastItem read GetItem write SetItem; default;
  end;

  TToastHideEvent = procedure(Sender: TObject; AIndex: integer) of object;
  TToastShowEvent = procedure(Sender: TObject; AIndex: integer; AElement: TJSHTMLElement) of object;

  TLibraryLevel = (llv4,llv5);

  TToast = class(TComponent)
  private
    FToastContainer: TJSHTMLElement;
    FItems: TToastCollection;
    FPosition: TToastPosition;
    FTimer: TTimer;
    FAutoHideDelay: integer;
    FContainer: TElementID;
    FX: integer;
    FY: integer;
    FClosePtr: pointer;
    FOnHide: TToastHideEvent;
    FLevel: TLibraryLevel;
    FOnShow: TToastShowEvent;
    procedure SetX(const Value: integer);
    procedure SetY(const Value: integer);
  protected
    procedure SetItems(const Value: TToastCollection);
    procedure UpdatePosition;
    procedure EnsureToastArea;
    procedure UpdateTimes(Sender: TObject);
    function HandleClose(Event: TEventListenerEvent): boolean; virtual;
    procedure DoHideToast(AIndex: integer); virtual;
  public
    constructor Create(AOwner: TComponent); override;
    destructor Destroy; override;
  published
    property AutoHideDelay: integer read FAutoHideDelay write FAutoHideDelay default 5000;
    property Container: TElementID read FContainer write FContainer;
    property Items: TToastCollection read FItems write SetItems;
    property Level: TLibraryLevel read FLevel write FLevel default llv5;
    property Position: TToastPosition read FPosition write FPosition;
    property X: integer read FX write SetX default 0;
    property Y: integer read FY write SetY default 0;
    property OnHide: TToastHideEvent read FOnHide write FOnHide;
    property OnShow: TToastShowEvent read FOnShow write FOnShow;
  end;

   TWebToast = class(TToast);

function CreateToast(ATitle, ABody, AID: string): TJSHTMLElement;

implementation

uses
  WEBLib.Forms;

function CreateToast(ATitle, ABody, AID: string): TJSHTMLElement;
var
  el: TJSHTMLElement;
  hdr,bdy: TJSHTMLElement;
begin
  el := TJSHTMLElement(document.createElement('DIV'));

  el.classList.Add('toast');
  el['data-autohide'] := 'false';
  el['id'] := AID;

  hdr := TJSHTMLElement(document.createElement('DIV'));
  hdr['class'] := 'toast-header';
  hdr.innerHTML := ATitle;

  bdy := TJSHTMLElement(document.createElement('DIV'));
  bdy['class'] := 'toast-body';
  bdy.innerHTML := ABody;

  el.appendChild(hdr);
  el.appendChild(bdy);

  Result := el;
end;

{ TToastCollection }

function TToastCollection.Add(AHeader, ABody: string): TToastItem;
begin
  Result := TToastItem(inherited Add);
  Result.Header := AHeader;
  Result.Body := ABody;
end;

function TToastCollection.Add: TToastItem;
begin
   Result := TToastItem(inherited Add);
end;

constructor TToastCollection.Create(AOwner: TComponent);
begin
  inherited Create(AOwner, TToastItem);
  FUniqueID := 0;
end;

function TToastCollection.GetItem(AIndex: integer): TToastItem;
begin
  Result := TToastItem(inherited Items[AIndex]);
end;

function TToastCollection.Insert(Index: integer): TToastItem;
begin
  Result := TToastItem(inherited Insert(Index));
end;

procedure TToastCollection.SetItem(AIndex: integer; const Value: TToastItem);
begin
  inherited Items[AIndex] := Value;
end;

{ TToastItem }

procedure TToastItem.Assign(Source: TPersistent);
begin
  if (Source is TToastItem) then
  begin
    FBody := (Source as TToastItem).Body;
    FHeader := (Source as TToastItem).Header;
    FCloseButton := (Source as TToastItem).CloseButton;
    FAutoHide := (Source as TToastItem).AutoHide;
    FTime := (Source as TToastItem).Time;
    FTag := (Source as TToastItem).Tag;
  end;
end;

constructor TToastItem.Create(ACollection: TCollection);
begin
  inherited;
  (ACollection as TToastCollection).UniqueID := (ACollection as TToastCollection).UniqueID + 1;
  FElementHandle := nil;
  FTime := ttNone;
  FCloseButton := true;
  FID := (ACollection as TToastCollection).UniqueID;
end;

procedure TToastItem.UpdateToast(el: TJSHTMLElement);
var
  hdr,bdy,btn,cap: TJSHTMLElement;
begin
  el.classList.Add('toast');

  if AutoHide then
  begin
    el['data-autohide'] := 'true';
    el['data-delay'] := IntToStr(Toast.AutoHideDelay);
  end
  else
    el['data-autohide'] := 'false';

  el['data-animation'] := 'true';
  el['role'] := 'alert';
  el['id'] := ToastID;
  el.style.setProperty('min-width','300px');

  hdr := TJSHTMLElement(document.createElement('DIV'));
  hdr['class'] := 'toast-header';

  cap := TJSHTMLElement(document.createElement('STRONG'));
  if (Collection.Owner as TToast).Level = llv4 then
    cap['class'] := 'mr-auto'
  else
    cap['class'] := 'me-auto';

  cap.innerHTML := FHeader;
  hdr.appendChild(cap);

  if Time <> ttNone then
  begin
    FElementTime := TJSHTMLElement(document.createElement('SMALL'));

    if Time = ttShow then
      FElementTime.innerHTML := TimeToStr(Now);

    hdr.appendChild(FElementTime);
  end;

  if CloseButton then
  begin
    btn := TJSHTMLElement(document.createElement('BUTTON'));
    btn['type'] := 'button';

    if (Collection.Owner as TToast).Level = llv4 then
    begin
      btn['class'] := 'ml-2 mb-1 close';
      btn['data-dismiss'] := 'toast';
    end
    else
    begin
      btn['class'] := 'btn-close';
      btn['data-bs-dismiss'] := 'toast';
    end;

    btn['data-id'] := ToastID;

    if (Collection.Owner as TToast).Level = llv4 then
      btn.innerHTML := '&times;';
    btn.addEventListener('click',Toast.FClosePtr);
    hdr.appendChild(btn);
  end;

  bdy := TJSHTMLElement(document.createElement('DIV'));
  bdy['class'] := 'toast-body';
  bdy.innerHTML := FBody;

  el.appendChild(hdr);
  el.appendChild(bdy);
end;

function TToastItem.CreateToast: TJSHTMLElement;
var
  el: TJSHTMLElement;
begin
  el := TJSHTMLElement(document.createElement('DIV'));
  UpdateToast(el);
  Result := el;
end;

destructor TToastItem.Destroy;
begin
  inherited;
end;

{$HINTS OFF}
procedure TToastItem.Hide;
var
  id: string;
begin
  if Assigned(FElementHandle) then
  begin
    id := ToastID;

    asm
      var tst = document.getElementById(id); //select id of toast
      var msg = new bootstrap.Toast(tst); //inizialize it
      msg.hide(); //show it
    end;

    FVisible := false;
  end;
end;

procedure TToastItem.SetVisible(const Value: boolean);
begin
  if (FVisible <> Value) then
  begin
    FVisible := Value;
    if FVisible then
      Show
    else
      Hide;
  end;
end;

procedure TToastItem.Show;
var
  id: string;
  el: TJSElement;
begin
  Toast.UpdatePosition;

  if not Assigned(FElementHandle) then
    FElementHandle := CreateToast;

  id := ToastID;

  el := Toast.FToastContainer;

  if (Toast.Position = tpContainer) and (Toast.Container <> '') then
  begin
    el := document.getElementById(Toast.Container);
    if not Assigned(el) then
      el := Toast.FToastContainer;
  end;

  if Assigned(Toast.OnShow) then
  begin
    Toast.OnShow(Toast, Index, FElementHandle);
  end;

  el.appendChild(FElementHandle);

  if  (id <> '') then
  begin
  asm
    var tst = document.getElementById(id);  //select id of toast
    var msg = new bootstrap.Toast(tst);  //inizialize it
    msg.show();  //show it
  end;
  end;

  FDispTime := Now;
  FVisible := true;
end;

{$HINTS ON}

function TToastItem.Toast: TToast;
begin
  Result := TToast(Collection.Owner);
end;

function TToastItem.ToastID: string;
begin
  Result := TComponent(Collection.Owner).Name + IntToStr(FID);
end;

procedure TToastItem.Update;
begin
  if Assigned(FElementHandle) then
  begin
    while FElementHandle.childElementCount > 0 do
      FElementHandle.removeChild(FElementHandle.firstChild);
  end
  else
    FElementHandle := CreateToast;

  UpdateToast(FElementHandle);
end;


{ TToast }

constructor TToast.Create(AOwner: TComponent);
begin
  inherited;
  FItems := TToastCollection.Create(Self);
  FToastContainer := nil;
  FTimer := TTimer.Create(Self);
  FTimer.OnTimer := UpdateTimes;
  FAutoHideDelay := 5000;
  FLevel := llv5;
  FClosePtr := @HandleClose;
end;


destructor TToast.Destroy;
begin
  FTimer.Free;
  inherited;
end;

procedure TToast.DoHideToast(AIndex: integer);
var
  Idx,i: integer;
begin
  Idx := -1;

  for i := 0 to Items.Count - 1 do
  begin
    if Items[i].FID = AIndex then
      Idx := i;
  end;

  if Idx = -1 then
    Exit;

  if Assigned(OnHide) then
    OnHide(Self, Idx);

  FItems[Idx].Hide;

  FItems.Delete(Idx);
end;

procedure TToast.EnsureToastArea;
begin
  if not Assigned(FToastContainer) then
  begin
    FToastContainer := TJSHTMLElement(document.createElement('DIV'));
    document.body.appendChild(FToastContainer);
  end;
end;

function TToast.HandleClose(Event: TEventListenerEvent): boolean;
var
  sid: string;
  id,e,l: integer;
begin
  sid := TJSHTMLElement(Event.target)['data-id'];

  l := Length(Name);
  Delete(sid,1,l);

  val(sid,id,e);
  if e = 0 then
  begin
    DoHideToast(id);
  end;
  Result := true;
end;

procedure TToast.SetItems(const Value: TToastCollection);
begin
  FItems.Assign(Value);
end;

procedure TToast.SetX(const Value: integer);
begin
  FX := Value;
end;

procedure TToast.SetY(const Value: integer);
begin
  FY := Value;
end;

procedure TToast.UpdatePosition;
var
  el: TJSHTMLElement;
begin
  EnsureToastArea;

  el := FToastContainer;

  case Position of
  tpTopLeft:
    begin
      el.style.setProperty('top','0');
      el.style.setProperty('left','0');
      el.style.removeProperty('right');
      el.style.removeProperty('bottom');
    end;
  tpTopRight:
    begin
      el.style.setProperty('top','0');
      el.style.removeProperty('left');
      el.style.setProperty('right','0');
      el.style.removeProperty('bottom');
    end;
  tpBottomLeft:
    begin
      el.style.removeProperty('top');
      el.style.setProperty('left','0');
      el.style.removeProperty('right');
      el.style.setProperty('bottom','0');
    end;
  tpBottomRight:
    begin
      el.style.removeProperty('top');
      el.style.removeProperty('left');
      el.style.setProperty('right','0');
      el.style.setProperty('bottom','0');
    end;
  tpAbsolute:
    begin
      el.style.setProperty('top',inttostr(FY)+'px');
      el.style.setProperty('left',inttostr(FX)+'px');
      el.style.removeProperty('right');
      el.style.removeProperty('bottom');
    end;
  end;

  el.style.setproperty('position','absolute');
  el.style.setproperty('z-index',(Application.MaxZIndex + 1).ToString);
end;

procedure TToast.UpdateTimes(Sender: TObject);
var
  i: integer;
  d: TDateTime;
  h,mi,se,se1100: word;
  s: string;
begin
  for i := 0 to FItems.Count - 1 do
  begin
    if (FItems[i].Visible) and (FItems[i].Time = ttDeltaShow) then
    begin
      d := Now - FItems[i].FDispTime;

      DecodeTime(d, h, mi, se, se1100);

      if h > 0 then
        s := inttostr(h) + 'h ' + inttostr(mi)+'m'
      else
        if mi > 0 then
          s := inttostr(h) + 'm ' + inttostr(se)+'s'
        else
          s := inttostr(se)+'s';

      FItems[i].FElementTime.innerHTML := s +' ago';
    end;
  end;
end;

end.
